import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { IdentityVerificationStatus } from '@40seas/entities/common';
import { z } from 'zod';

export const BusinessIdentityVerificationSchema = z.object({
    status: EnumSchema(IdentityVerificationStatus).nullish(),
    isRequired: z.boolean().optional().nullish(),
});

export class BusinessIdentityVerification extends FromSchema(BusinessIdentityVerificationSchema) {
    status?: IdentityVerificationStatus;
    isRequired?: boolean;
}
